// src/services/courseService.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const coursesCollection = collection(db, "courses");

export const getCourses = async () => {
  const snapshot = await getDocs(coursesCollection);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const createCourse = async (courseData) => {
  const docRef = await addDoc(coursesCollection, courseData);
  return docRef.id;
};

export const updateCourse = async (courseId, updatedData) => {
  const courseDoc = doc(db, "courses", courseId);
  await updateDoc(courseDoc, updatedData);
};

export const deleteCourse = async (courseId) => {
  const courseDoc = doc(db, "courses", courseId);
  await deleteDoc(courseDoc);
};
